<template>
    <span>{{ value }}</span>
</template>

<script>
import moment from 'moment';

export default {
  name: 'CellRendererDate',
  computed: {
    value () {
      const { value } = this.params;

      if (!value) {
        return '';
      }

      return moment(value).format('DD/MM/YYYY')
    }
  }
}
</script>
